import React from 'react';

import { DEFAULT_PRECISION, Tooltip } from '@make-software/cspr-design';
import Big from 'big.js';
import {
  formatTokenAmount,
  getAmountFromMotes,
} from '../../utils/ft-token-amount';
import FullPrecisionTooltip from '../full-precision-tooltip/full-precision-tooltip';

export interface TokenAmountProps {
  amount: string | null;
  decimals?: number;
  symbol?: string;
  precision?: number;
  shouldShortenAmount?: boolean;
}

export function TokenAmount({
  amount,
  decimals,
  symbol = '',
  precision = DEFAULT_PRECISION,
  shouldShortenAmount = false,
}: TokenAmountProps) {
  if (amount == null) {
    return <>{'N/A'}</>;
  }

  const calculatedAmount: string = decimals
    ? getAmountFromMotes(amount, decimals)
    : Big(amount.toString() || '0').toString();

  const formattedAmount = formatTokenAmount(
    calculatedAmount,
    precision,
    shouldShortenAmount
  );
  const formattedText = formattedAmount + ` ${symbol}`;

  return (
    <FullPrecisionTooltip amount={calculatedAmount} symbol={symbol}>
      {formattedText}
    </FullPrecisionTooltip>
  );
}

export default TokenAmount;
